
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "Login"
})
export default class extends Vue {
  created() {
    UserModule.RedirectToLogin();
  }

  render() {
    // Avoid warning for missing template
  }
}
